import { Component} from '@angular/core';

@Component({
  selector: 'lib-done-outline-svg',
  templateUrl: './done-outline.component.svg'
})
export class DoneOutlineSvgComponent {
  fillColor = 'rgb(0, 153, 0)';
}

